import request from '@/utils/request'

// 登录请求
export const loadPage = (params) => {
  return request({
    url: '/user/super/admin/page',
    method: 'get',
    params
  })
}

// 获取圈管理员列表
export const getAdminListApi = (params) => {
  return request({
    url: '/circle/admin/admin/GetadminList',
    method: 'get',
    params
  })
}

export const rightsList = () => {
  return request({
    url: '/user/super/admin/rights',
    method: 'get',
  })
}

export const saveSuperAdmin = (data) => {
  return request({
    url: '/user/super/admin/save',
    method: 'post',
    data
  })
}
export const getSuperAdmin = (id) => {
  return request({
    url: `/user/super/admin/detail/${id}`,
    method: 'get',
  })
}

export const updateSuperAdmin = (data) => {
  return request({
    url: '/user/super/admin/update',
    method: 'put',
    data
  })
}

export const removeSuperAdmin = (id) => {
  return request({
    url: `/user/super/admin/remove/${id}`,
    method: 'delete',
  })
}

// 帖子排行榜
export const getSortPostList = (url, params) => {
  return request({ url, method: 'get', params })
}

// 任务中心
export const getTaskCenterListApi = (params) => {
  return request({
    url: '/task',
    method: 'get',
    params
  })
}

// 编辑任务
export const updateTaskApi = (data, type) => {
  return request({
    url: '/task',
    method: type,
    data
  })
}

// 删除任务
export const removeTaskApi = (id) => {
  return request({
    url: `/task/${id}`,
    method: 'delete',
  })
}

// 小程序实时在线用户
export const getAppOnlineUserListApi = () => {
  return request({
    url: '/app/online/list',
    method: 'get'
  })
}

// 匿名配置 
export const updateAnonyConfigApi = (data) => {
  return request({
    url: '/setting/circle/anonymous',
    method: 'post',
    data
  })
}

// 获取匿名设置
export const getAnonyConfigApi = () => {
  return request({
    url: '/setting/circle/anonymous',
    method: 'get',
  })
}

// 通过用户id获取禁言总条数
export const getMuteCountApi = (userId) => {
  return request({
    url: `/mute/admin/count/${userId}`,
    method: 'get',
  })
}

// 根据用户ID查询封禁总条数
export const getBanCountApi = (userId) => { 
  return request({
    url: `/ban/admin/count/${userId}`,
    method: 'get',
  })
}

// 新增圈子管理员/圈主
export const addCircleAdminApi = (data) => {
  return request({
    url: "/circle/admin/addAdmin",
    method: "post",
    data
  });
};

// 分页查询关于我们列表
export const getAboutUsPageApi = (params) => {
  return request({
    url: '/aboutUs/page',
    method: 'get',
    params
  })
}

// 新增关于我们
export const addAboutUsApi = (data, type) => {
  return request({
    url: '/aboutUs',
    method: type,
    data
  })
}

// 删除关于我们
export const deleteAboutUsApi = (id) => {
  return request({
    url: `/aboutUs/delete?id=${id}`,
    method: 'delete',
  })
}
